import { useCallback } from 'react';
import { ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../hooks/redux';
import { ModalBox } from '../../../../../components';
import { getDisplayName } from '../../../../../utils/userDisplayName';
import { ClassTeam } from '../ClassesTag/ClassesTag';

export const SplitTeamModal = (props: ModalProps) => {
    const {
        team,
        onSplit,
    }: {
        team: ClassTeam;
        onSplit: () => void;
    } = useAppSelector((state) => state.modals.data);

    const { t } = useTranslation();
    const prefix = 'splitTeamModal-';

    const handleSave = useCallback(() => {
        onSplit();
        props.onHide?.();
    }, [onSplit, props]);

    return (
        <ModalBox
            {...props}
            title={t(prefix + 'title')}
            btnText={t(prefix + 'splitButton')}
            handleSave={handleSave}
        >
            <div className="d-flex flex-column gap-3">
                <div className="border rounded p-3 bg-light">
                    <h6 className="mb-2 fw-bold">{team.name}</h6>
                    <div>
                        <strong>{t(prefix + 'players')}:</strong>{' '}
                        {team.users.map(getDisplayName).join(', ')}
                    </div>
                </div>
                <div className="alert alert-warning mb-0">
                    {t(prefix + 'confirmMessage')}
                </div>
            </div>
        </ModalBox>
    );
};
